export default "__VITE_ASSET__BED97j38__"